import { section } from '@/glow';
import { AnimateTextColumnsWithImages } from '@/lib/animation';

section('text-columns-with-images', {
  onLoad() {
    this.AnimateTextColumnsWithImages = AnimateTextColumnsWithImages(this.container);
  },

  onUnload() {
    this.AnimateTextColumnsWithImages?.disconnect();
  }
});
